import { Eyebrow } from "@/components/primitives";
import { Reveal } from "@/components/motion/Reveal";
import GrowthRing from "@/components/visuals/GrowthRing";
import Breadcrumbs from "@/components/Breadcrumbs";

// Consistent inner-page hero with optional breadcrumbs.
export default function PageHero({ eyebrow, heading, copy, breadcrumbs, children }) {
  return (
    <section className="relative bg-white pt-28 md:pt-36 pb-14 md:pb-20 overflow-hidden">
      <div
        aria-hidden="true"
        className="pointer-events-none absolute -right-40 -top-24 opacity-70"
      >
        <GrowthRing size={440} duration={80} />
      </div>
      <div className="relative mx-auto max-w-7xl px-5 sm:px-8">
        {breadcrumbs && (
          <div className="mb-8">
            <Breadcrumbs items={breadcrumbs} />
          </div>
        )}
        <div className="max-w-3xl">
          {eyebrow && (
            <Reveal>
              <Eyebrow>{eyebrow}</Eyebrow>
            </Reveal>
          )}
          <Reveal delay={0.05}>
            <h1 className="mt-5 text-4xl sm:text-5xl lg:text-6xl font-extrabold tracking-tight leading-[1.05] text-forest text-balance">
              {heading}
            </h1>
          </Reveal>
          {copy && (
            <Reveal delay={0.1}>
              <p className="mt-6 text-lg md:text-xl text-mid-neutral leading-relaxed">
                {copy}
              </p>
            </Reveal>
          )}
          {children && (
            <Reveal delay={0.15}>
              <div className="mt-8">{children}</div>
            </Reveal>
          )}
        </div>
      </div>
    </section>
  );
}
